import {ajax} from '../../common/utils.js';
import {SET_MEMBER_DATA, SET_MEMBER_ACTION, SET_MEMBER_KEY, INIT_MEMBER_DETAILS,
    SET_UPDATE_MEMBER_ERROR, SET_SHOW_PASSWORD, SET_ADDRESS_VALIDATION_ERROR, SET_LAT_LNG, SET_ADDRESS_VALIDATION_ERROR_NO_ACTION} from "../actionTypes";
import {gotoStep} from "../join/joinActions";
import {MemberActions, FetchingTypes, URLs, NO_COOKIE_CREATE} from "../../common/constants";
import {createWaitListSubscription} from "../common/subscriptionSummaryActions";
import {fetchingData, dataFetched, errorFetching, isFetching} from "../common/fetchingActions";

export function setMemberData(member) {
    return {
        type: SET_MEMBER_DATA,
        memberDetails: member
    }
}
export function initMemberData() {
    return {
        type: INIT_MEMBER_DETAILS
    }
}
export function setMemberAction(memberAction) {
    return {
        type: SET_MEMBER_ACTION,
        memberAction: memberAction,
    }
}
export function setMemberKey(memberKey) {
    return {
        type: SET_MEMBER_KEY,
        memberKey: memberKey
    }
}
export function getMember(memberKey) {
    return function (dispatch, getState) {
        const fetchUrl = '/dispatcher/SignupService.getMember';
        const data = {
            farmKey: getState().staticData.farmKey,
            memberKey: memberKey
        };
        return ajax(fetchUrl, data)
            .then(member => dispatch(setMemberData(member)));
    }
}
export function updateMember(contactDetails, step, waitListItems) {
    return function(dispatch, getState) {
        const state = getState();
        if(isFetching(state, FetchingTypes.VALIDATE_UPDATE_MEMBER)) {
            return;
        }
        const memberKey = state.memberDetails?state.memberDetails.key:null;
        const fetchUrl = '/dispatcher/SignupService.updateMember';
        const password = contactDetails.password;
        delete contactDetails.password;
        delete contactDetails.retypedPassword;
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: memberKey,
            password: password,
            contactDetails: JSON.stringify(contactDetails)
        };
        dispatch(fetchingData(FetchingTypes.VALIDATE_UPDATE_MEMBER));
        return ajax(fetchUrl, data)
            .then(response => {
                if (response === "Member with this email already exists") {
                    response = "Email already exists. Switch to Login tab and use your existing email and password";
                    dispatch(setUpdateMemberError(response));
                    dispatch(dataFetched());
                } else {
                    if (!document.cookie.includes("farmigoMember"))
                        throw new Error(NO_COOKIE_CREATE);
                    dispatch(setMemberKey(response));
                    dispatch(getMember(response));
                    if(waitListItems) {
                        dispatch(createWaitListSubscription(response, waitListItems));
                    }
                    else if(step){
                        if(step !== URLs.ACCOUNT) {
                            dispatch(gotoStep(step));
                        }
                        dispatch(dataFetched());
                    }
                }
            })
            .then(() => dispatch(setMemberAction(MemberActions.NO_ACTION)))
            .catch(error => dispatch(errorFetching(error)))
    }
}
export function setAddressValidationError(error) {
    return {
        type: SET_ADDRESS_VALIDATION_ERROR,
        error: error
    }
}
export function setAddressValidationErrorNoAction(error) {
    return {
        type: SET_ADDRESS_VALIDATION_ERROR_NO_ACTION,
        error: error
    }
}
export function setUpdateMemberError(error) {
    return {
        type: SET_UPDATE_MEMBER_ERROR,
        error: error
    }
}
export function setShowPassword(showPassword) {
    return {
        type: SET_SHOW_PASSWORD,
        showPassword
    }
}
export function updateMemberLatLng(lat, lng) {
    return function(dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.updateMemberLatLng';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            lat: lat,
            lng: lng
        };
        dispatch(fetchingData(FetchingTypes.UPDATE_LAT_LNG));
        return ajax(fetchUrl, data)
            .then(() => dispatch(dataFetched()))
            .catch(error => dispatch(errorFetching(error)))
    }
}
export function setLatLng(lat, lng) {
    return {
        type: SET_LAT_LNG,
        lat,
        lng
    }
}


// WEBPACK FOOTER //
// ./src/actions/login/memberDetailsActions.js